import { Route } from 'react-router-dom';
import { InventoryProvider } from '../serviceContextManager/inventory/InventoryServiceManager';
import { CatalogProvider } from '../serviceContextManager/catalog/CatalogServiceManager';

import { HistoryCardProvider } from '../serviceContextManager/historyCards/HistoryCardServiceManager';
import { ReassignmentProvider } from '../serviceContextManager/reassignment/ReassignmentServiceManager';
import {
  Catalogs,
  HistoryCard,
  HistorySam,
  Inventory,
  RedirectComponent,
  Roles,
  UserHistory,
  UserManager,
  Reassigment,
  HistoryDevice,
  SandboxScreen,
} from 'src/pages/index';
import { AccessListValues, PermitsList } from '../permitsList';
import { SandboxProvider } from '../serviceContextManager/Sandbox/SandboxServiceManager';

interface IRouterProps {
  path: string;
  name: string;
  permit: number;
  element: React.ReactNode;
  component?: JSX.Element;
}

const routerBrowser: IRouterProps[] = [
  {
    path: '/',
    name: 'inventario',
    permit: AccessListValues.SAM_INVENTORY_LIST,
    element: (
      <InventoryProvider>
        <Inventory />
      </InventoryProvider>
    ),
  },
  {
    path: '/inventario',
    name: 'inventario',
    permit: AccessListValues.SAM_INVENTORY_LIST,
    element: (
      <InventoryProvider>
        <Inventory />
      </InventoryProvider>
    ),
  },
  {
    path: '/reassignment',
    name: 'reassignment',
    permit: AccessListValues.OP_REASSIGN_SAM_LIST,
    element: (
      <ReassignmentProvider>
        <Reassigment />
      </ReassignmentProvider>
    ),
  },
  {
    path: '/history-sam',
    name: 'Historial de sam',
    permit: AccessListValues.HISTORY_GENERAL,
    element: <HistorySam />,
  },
  {
    path: '/catalogos',
    name: 'catalog',
    permit: AccessListValues.CATALOGS_LIST,
    element: (
      <CatalogProvider>
        <Catalogs />
      </CatalogProvider>
    ),
  },
  {
    path: '/administrar-usuarios',
    name: 'usuarios',
    permit: AccessListValues.SEC_USERS_LIST,
    element: <UserManager />,
  },
  {
    path: '/history-cards',
    name: 'Historial de tarjetas',
    permit: AccessListValues.HISTORY_GENERAL,
    element: (
      <HistoryCardProvider>
        <HistoryCard />
      </HistoryCardProvider>
    ),
  },
  {
    path: '/sandbox',
    name: 'Sandbox',
    permit: AccessListValues.SANDBOX_LIST,
    element: (
      <SandboxProvider>
        <SandboxScreen />
      </SandboxProvider>
    ),
  },
  {
    path: '/history-device',
    name: 'Historial de dispositivos',
    permit: AccessListValues.HISTORY_GENERAL,
    element: <HistoryDevice />,
  },
  {
    path: '/history-user',
    name: 'historial de usuarios',
    permit: AccessListValues.HISTORY_USERS,
    element: <UserHistory />,
  },
  {
    path: '/roles',
    name: 'roles',
    permit: AccessListValues.SEC_ROLE_LIST,
    element: <Roles />,
  },
  {
    path: '/denegado',
    name: 'denegado',
    permit: 0,
    element: <RedirectComponent />,
  },
  {
    path: '*',
    name: 'notFound',
    permit: AccessListValues.SAM_INVENTORY_LIST,
    element: (
      <div className="flex flex-col items-center justify-center w-full h-full">
        <span className="bold text-xl">
          La página solicitada no existe o no cuenta con los permisos requeridos
        </span>
      </div>
    ),
  },
];

const RouterConfig = () => {
  return (
    <>
      {routerBrowser.map(route => (
        <Route key={route.name} path={route.path} element={route.element} />
      ))}
    </>
  );
};

export default RouterConfig;
